import React, { useEffect } from "react";
import "./PrivacyPolicy.css";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = "Privacy Policy | The Party Parlour";
  }, []);

  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1>Privacy Policy</h1>
        <p className="privacy-updated">Last updated: September 1, 2026</p>

        <p>
          The Party Parlour ("we", "us") respects your privacy. This policy
          explains what personal information we collect, how we use it, and
          the choices you have. We handle personal information in accordance
          with Canada's Personal Information Protection and Electronic
          Documents Act (PIPEDA) and applicable provincial law.
        </p>

        <h2>Information We Collect</h2>
        <ul>
          <li>
            <strong>Inquiry details.</strong> When you submit our contact
            form, we collect the information you provide: your name, email
            address, and optionally your phone number, event date, package
            interest, and message.
          </li>
          <li>
            <strong>Event photos.</strong> When we operate a booth at your
            event, we capture photos of guests who choose to use it, along
            with the digital files delivered to you.
          </li>
          <li>
            <strong>Basic technical data.</strong> Like most websites, our
            hosting provider may process limited technical information (such
            as IP address) needed to serve the site securely and prevent
            abuse.
          </li>
        </ul>

        <h2>How We Use Your Information</h2>
        <ul>
          <li>To respond to your inquiry and provide quotes and availability.</li>
          <li>To plan, deliver, and follow up on your booking and the Services.</li>
          <li>To deliver your event photos and provide access to your gallery.</li>
          <li>To protect the site and our Services from spam and abuse.</li>
          <li>
            With your consent, to feature a limited selection of event photos
            in our marketing (for example, our website or social media).
          </li>
        </ul>

        <h2>Consent and Marketing Use of Photos</h2>
        <p>
          We use event photos for promotion only where permitted. If you or a
          guest would prefer that images not be used for marketing, contact
          us and we will remove them from promotional use. You may withdraw
          consent at any time; this does not affect the delivery of Services
          already provided.
        </p>

        <h2>Sharing Your Information</h2>
        <p>
          We do not sell your personal information. We may share it with
          trusted service providers who help us operate (for example, website
          hosting, online galleries, or email delivery), and only as needed
          to provide the Services. We may also disclose information where
          required by law.
        </p>

        <h2>Data Retention</h2>
        <p>
          We keep personal information only as long as necessary for the
          purposes described here or as required by law, after which it is
          deleted or anonymized.
        </p>

        <h2>Cookies and Tracking</h2>
        <p>
          This website does not use advertising or third-party tracking
          cookies. Any cookies used are limited to what is necessary for the
          site to function.
        </p>

        <h2>Security</h2>
        <p>
          We use reasonable technical and organizational measures to protect
          personal information. No method of transmission or storage is
          completely secure, but we work to safeguard the information in our
          care.
        </p>

        <h2>Your Rights</h2>
        <p>
          You may request access to the personal information we hold about
          you, ask us to correct it, or request that we delete it, subject to
          legal limits. To make a request, contact us through the{" "}
          <Link to="/Contact">form on our homepage</Link>.
        </p>

        <h2>Children</h2>
        <p>
          Our Services are directed to event organizers and are not intended
          for children. We do not knowingly collect personal information
          from children without appropriate consent.
        </p>

        <h2>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. The "Last
          updated" date above reflects the current version.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about your privacy or this policy? Reach us through the{" "}
          <Link to="/Contact">contact form on our homepage</Link>.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;